import { useConstant } from './useConstant'

export function useConstantCallback<T extends (...args: unknown[]) => unknown>(
  callback: T
): T {
  return useConstant(() => callback)
}
